import { AUTH_BACKUP_CODE_LABEL, AUTH_BACKUP_CODE_LENGTH, AUTH_CODE_PLACEHOLDER } from 'common/constants/auth';
import { AuthTextField } from 'pages/Auth/components/AuthTextField';
import { AuthenticationBackupCodesInputProps } from './AuthenticationBackupCodesInput.props';

const normalizeFieldMessages = (value?: string | string[]) => {
  if (!value) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
};

const AuthenticationBackupCodesInput = ({
  disabled = false,
  formState,
  handleBlur,
  handleChange,
  inputRef,
  onKeyDown,
}: AuthenticationBackupCodesInputProps) => {
  const { dbErrors, errors, touched, values } = formState;
  const validationMessages = normalizeFieldMessages(errors?.backupCode);
  const serverMessages = normalizeFieldMessages(dbErrors?.backupCode);
  const helperText = touched.backupCode ? validationMessages[0] : undefined;
  const hasError = Boolean(helperText || serverMessages[0]);

  return (
    <AuthTextField
      autoCapitalize="off"
      autoComplete="one-time-code"
      autoCorrect="off"
      disabled={disabled}
      id="enter-user-backup-code"
      slotProps={{
        htmlInput: {
          maxLength: AUTH_BACKUP_CODE_LENGTH,
          onBlur: handleBlur,
          pattern: '[a-z2-7]*',
          spellCheck: false,
        },
      }}
      name="backupCode"
      label={AUTH_BACKUP_CODE_LABEL}
      placeholder={AUTH_CODE_PLACEHOLDER}
      type="text"
      error={hasError}
      helperText={helperText}
      value={values.backupCode || ''}
      inputRef={inputRef}
      onChange={handleChange}
      onKeyDown={onKeyDown}
    />
  );
};

export default AuthenticationBackupCodesInput;
